// extracted by mini-css-extract-plugin
export default {"create-folder":"CreateFolder_create-folder__hscF-"};